import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import Link from "../Link";

var FilterGroup = function FilterGroup(_ref) {
  var children = _ref.children,
      href = _ref.href,
      title = _ref.title;
  var getClassName = getClassNameFactory("SearchFiltersFilterGroup");
  return /*#__PURE__*/React.createElement("li", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "title"
    })
  }, /*#__PURE__*/React.createElement(Link, {
    href: href
  }, title)), /*#__PURE__*/React.createElement("ul", {
    className: getClassName({
      descendantName: "items"
    })
  }, children));
};

FilterGroup.displayName = "SearchFilters.FilterGroup";
export default FilterGroup;